// Generated from packages/contracts/errors.ts by scripts/generate-client.mjs; do not edit.
const connectModel = {
  label: "Connect a model",
  route: "#/settings/team/models",
};
const signIn = { label: "Sign in again", route: "#" };
const catalogue = {
  workspace_pdf_not_configured: {
    title: "PDF reading is unavailable",
    message:
      "Ask this installation's operator to enable private PDF text reading before granting access.",
  },
  workspace_pdf_grant_requires_attachments: {
    title: "Allow attachment reading first",
    message:
      "On this Workspace account, enable attachment reading before allowing PDF text excerpts.",
  },
  workspace_pdf_unsupported: {
    title: "This PDF cannot be read",
    message:
      "Attach a PDF of at most 1 MiB to the message you want answered. Other files and unrelated attachments cannot be selected.",
  },
  workspace_pdf_unreadable: {
    title: "The PDF text could not be read",
    message:
      "Use an unlocked, valid PDF with selectable text, or attach a plain text copy. Scanned images need OCR and are not read.",
  },
  workspace_pdf_busy: {
    title: "The PDF reader is busy",
    message: "Wait for its current document to finish, then try again.",
    retryable: true,
  },
  workspace_pdf_unavailable: {
    title: "The PDF reader is unavailable",
    message:
      "Try again later. If this continues, ask the installation's operator to check PDF reading.",
    retryable: true,
  },
  workspace_pdf_cancelled: {
    title: "PDF reading stopped",
    message: "Start a new request if you still want this attachment read.",
  },
  workspace_pdf_reference_changed: {
    title: "The PDF source changed",
    message:
      "Attach the current file to a new message. The bot cannot use an earlier excerpt after its source changes.",
  },
  workspace_file_changed: {
    title: "The source file changed",
    message:
      "Attach the current file to a new message so the bot can check its contents again.",
  },
  workspace_file_not_paused: {
    title: "File transfer is busy",
    message:
      "Wait for the current transfer to finish, then refresh its activity.",
    retryable: true,
  },
  workspace_file_intent_required: {
    title: "File approval required",
    message:
      "Start a file upload and approve its exact content before continuing.",
  },
  workspace_file_intent_changed: {
    title: "File content changed",
    message:
      "This transfer is bound to the original file. Start a new request for different content.",
  },
  workspace_transfer_outcome_unknown: {
    title: "Check this file in Workspace",
    message:
      "The transfer stopped before its outcome could be recorded. Check Workspace before starting another upload to avoid creating a duplicate.",
  },
  workspace_file_scan_blocked: {
    title: "Workspace blocked this file",
    message:
      "The file failed scanning or is no longer available. Review it in Workspace before making another request.",
  },
  workspace_invalid_upload_status: {
    title: "Workspace returned an invalid file status",
    message:
      "The response did not match this file. Refresh the transfer after checking Workspace.",
    retryable: true,
  },
  workspace_source_changed: {
    title: "Workspace source changed",
    message:
      "The original message or an attachment changed or became unavailable. Send a new request using the current source. Review any pending Workspace approvals separately.",
  },
  workspace_attachment_not_in_turn: {
    title: "File is outside this request",
    message:
      "Choose an attachment from the exact message this bot is answering. This permission does not include other files.",
  },
  workspace_file_review_required: {
    title: "Workspace file review needed",
    message:
      "Workspace requires a review before this file can be provided to the model. The content has not been imported. Resolve the policy warning in Workspace before sending a new request.",
  },
  workspace_capabilities_changed: {
    title: "Background permissions changed",
    message:
      "This turn used an older background grant and was stopped. Send a new request to use the current grant. Review any pending Workspace approvals separately.",
  },
  workspace_enrollment_locked: {
    title: "Request already submitted",
    message:
      "Its identity, permissions and key are fixed for safe retries. Ask the Workspace administrator to downscope or reject it; do not create another identity to retry.",
  },
  workspace_key_proof_required: {
    title: "Update Workspace to recover this request",
    message:
      "This Workspace version cannot verify the original bot key. Upgrade Workspace before retrying with a changed installation credential.",
  },
  workspace_status_request_unresolved: {
    title: "Original account request not found",
    message:
      "Ask the Workspace administrator to locate the existing request, then check again using the same bot identity.",
  },
  workspace_status_grant_revoked: {
    title: "Automatic status checks stopped",
    message:
      "The bot, its owner's access or installation credential changed. Review the request and save automatic checks again.",
  },
  workspace_status_polling_capacity: {
    title: "Automatic check limit reached",
    message:
      "Stop another active account-request check before enabling this one. Up to 16 requests can be checked at once.",
  },
  workspace_status_polling_finished: {
    title: "Request no longer needs status checks",
    message:
      "Refresh this request. If Workspace approved it, connect the account while signed in.",
  },
  workspace_status_check_failed: {
    title: "Workspace status unavailable",
    message:
      "The saved request will be checked again after the next scheduled time.",
    retryable: true,
  },
  workspace_setup_changed: {
    title: "Installation credential changed",
    message:
      "The installation credential changed. Review and confirm the current credential to check the original request. Recovery requires Workspace proof of the same bot key.",
  },
  workspace_receipt_invalid: {
    title: "Workspace returned an inconsistent account",
    message:
      "The account receipt did not match the original request. No new permissions were granted in Helix Agentspace. Ask the operator to inspect the request.",
  },
  workspace_setup_required: {
    title: "Installation credential required",
    message:
      "Ask the operator to configure this team's Workspace setup credential. Each bot keeps its own separate account.",
  },
  workspace_setup_invalid: {
    title: "Installation credential configuration needs attention",
    message:
      "The protected setup file must contain the installation key and match the configured Workspace API origin.",
  },
  workspace_enrollment_unavailable: {
    title: "Account enrollment unavailable",
    message:
      "Workspace did not advertise the required enrollment tools. Check its version and the installation credential's permissions.",
  },
  workspace_setup_check_failed: {
    title: "Installation access could not be verified",
    message:
      "Workspace did not complete the account-request status check. Check the setup credential and any Workspace approval requirement.",
  },
  workspace_request_exists: {
    title: "Account request already prepared",
    message:
      "Open the saved request for this bot and Workspace installation to review or edit it. A new request key is not needed.",
  },
  workspace_installation_required: {
    title: "Workspace installation unavailable",
    message:
      "Ask the operator to enable the original trusted Workspace installation. Other bots and connections still work.",
  },
  workspace_identity_immutable: {
    title: "This identity is pinned",
    message:
      "A Workspace account belongs to one bot and actor. Add a separate account to use a different identity or installation.",
  },
  workspace_identity_already_bound: {
    title: "Workspace identity already connected",
    message:
      "Use a separately provisioned Workspace agent for this bot. Existing identity bindings are retained after an account is removed.",
  },
  workspace_credential_binding_required: {
    title: "Dedicated credential required",
    message:
      "This credential is bound to another connection. Issue a separate credential for this Workspace identity.",
  },
  workspace_credential_expired: {
    title: "Workspace credential expired",
    message:
      "Open this Workspace account and replace its credential with a newly issued token and expiry.",
  },
  workspace_credential_revision_changed: {
    title: "Workspace credential changed",
    message:
      "Reconnect this Workspace account and confirm its bot access before continuing.",
  },
  workspace_agent_binding_required: {
    title: "Account belongs to another bot",
    message:
      "Give this bot its own dedicated Workspace account. Its other connections are unchanged.",
  },
  workspace_owner_required: {
    title: "Choose your own account",
    message:
      "The person setting up this account must be its owner. Workspace approval ownership is configured separately.",
  },
  workspace_resource_approval_not_executed: {
    title: "Workspace approval is not complete",
    message:
      "Check the original action\u2019s Workspace status. Only an executed approval permits rereading the same resource; do not resubmit the original action.",
  },
  workspace_standing_grant_required: {
    title: "Workspace access needs review",
    message:
      "Confirm the current account and bot grant before running this operation.",
  },
  workspace_status_discovery_failed: {
    title: "Cannot check Workspace status",
    message:
      "Check the account credential, expiry and connection, then retry the status check. The original action has not been resubmitted.",
  },
  workspace_status_tool_unavailable: {
    title: "Workspace status access unavailable",
    message:
      "The credential cannot discover actions.get. Ask the Workspace administrator to review its platform.read scope.",
  },
  workspace_pending_action_required: {
    title: "No pending Workspace action",
    message:
      "Choose the original pending action on this account. A transport error is not an approval request.",
  },
  workspace_account_required: {
    title: "Workspace account changed",
    message:
      "Reopen the current Workspace account before continuing. Earlier actions stay bound to their original account revision.",
  },
  // Models and providers
  terminal_control_changed: {
    title: "Terminal control changed",
    message:
      "Refresh the terminal and take control before typing. Nothing is resent automatically.",
  },
  terminal_control_required: {
    title: "You are watching this terminal",
    message: "Take control before sending input.",
  },
  terminal_control_busy: {
    title: "Someone else controls this terminal",
    message:
      "Wait for them to release control. The shell's creator can take it back.",
  },
  managed_account_invalid: {
    title: "Account details do not match this connector",
    message:
      "Check the required settings and credentials. If the connector changed, add an account from its current catalog entry.",
  },
  terminal_input_pending: {
    title: "Terminal input is still pending",
    message:
      "Wait for the executor to acknowledge the current input before handing over control.",
  },
  terminal_recipient_ineligible: {
    title: "This person cannot use the terminal",
    message:
      "Terminal sharing currently requires an active owner or admin in this team.",
  },
  terminal_self_share: {
    title: "This is already your terminal",
    message: "Choose another team member to share with.",
  },
  terminal_share_limit: {
    title: "This terminal has enough participants",
    message: "Remove an existing invitation before adding another person.",
  },
  provider_unavailable: {
    title: "No model is connected",
    message:
      "This bunny can't reach a model. Connect a model provider to start chatting.",
    action: connectModel,
  },
  provider_auth_expired: {
    title: "The model login expired",
    message: "Sign in to the model provider again, then resend your message.",
    action: connectModel,
  },
  model_login_in_progress: {
    title: "A ChatGPT sign-in is already in progress",
    message:
      "Finish or cancel the current sign-in, or try again after its code expires.",
  },
  model_login_expired: {
    title: "The ChatGPT sign-in code expired",
    message: "Start sign-in again to get a fresh code.",
  },
  model_login_failed: {
    title: "ChatGPT sign-in did not finish",
    message:
      "Try again. Enable device code sign-in in your ChatGPT security settings or workspace permissions, and approve the code requested by this Agentspace installation.",
  },
  model_unavailable: {
    title: "This model isn't available",
    message: "Choose another model for this bunny, or connect its provider.",
    action: connectModel,
  },
  model_not_configured: {
    title: "No model is selected",
    message: "Choose a model for this bunny before sending.",
    action: connectModel,
  },
  model_image_input_unsupported: {
    title: "This model can't read images",
    message: "Remove the image, or choose a model that accepts images.",
  },
  model_image_input_limit: {
    title: "Too many images",
    message:
      "This model accepts fewer images per message. Remove some and resend.",
  },
  provider_error: {
    title: "The model returned an error",
    message:
      "The provider couldn't complete this reply. Try again in a moment.",
    retryable: true,
  },
  provider_rejected: {
    title: "The model declined this request",
    message:
      "The provider rejected the message. Rephrase it or try another model.",
  },
  provider_outcome_unknown: {
    title: "The reply may be incomplete",
    message:
      "We lost contact with the model before it confirmed. Check the conversation before retrying.",
  },
  provider_retry_not_due: {
    title: "Retrying too soon",
    message: "Wait a moment before retrying this message.",
    retryable: true,
  },
  provider_rate_limited: {
    title: "The model is busy",
    message: "The provider is limiting requests. Try again shortly.",
    retryable: true,
  },
  // FLOW-04: a provider limit, before and after the run did anything.
  provider_quota: {
    title: "The model's usage limit was reached",
    message:
      "The provider refused before anything ran. Work waits and resumes when the limit resets; Overview shows when.",
    action: { label: "See usage and limits", route: "#/overview" },
    retryable: true,
  },
  provider_quota_after_effect: {
    title: "The usage limit was reached partway through",
    message:
      "A tool had already run when the provider refused, so the run stopped and will not be replayed. Check what it did, then ask again after the limit resets.",
    action: { label: "See usage and limits", route: "#/overview" },
  },
  // OPS-03: spend budgets
  spend_budget: {
    title: "The spend budget is used up",
    message:
      "This run would go over a spend budget, so it did not start. Raise the budget in Spending, or try again after it resets.",
    action: { label: "Open Spending", route: "#/settings/team/spending" },
  },
  spend_budget_after_effect: {
    title: "The spend budget ran out partway through",
    message:
      "A tool had already run when the budget ran out, so the run stopped and will not be replayed. Check what it did, then raise the budget or ask again.",
    action: { label: "Open Spending", route: "#/settings/team/spending" },
  },
  spend_budget_exists: {
    title: "That budget already exists",
    message:
      "The team, and each project, has one spend budget. Change the existing one instead.",
  },
  invalid_budget: {
    title: "Check the budget",
    message: "Enter an amount above $0 and at most $1,000,000.",
  },
  invalid_price: {
    title: "Check the prices",
    message:
      "Prices are US dollars per million tokens, between 0 and 100,000, and a model needs an input or output price.",
  },
  // OPS-01: support exports
  support_export_expired: {
    title: "This support export has expired",
    message:
      "Support exports can be downloaded for 15 minutes after they are prepared. Prepare a new one.",
  },
  // Conversations and runs
  context_limit: {
    title: "The conversation is too long",
    message:
      "This reply needs more context than the model allows. Start a checkpoint or shorten the request.",
  },
  output_limit: {
    title: "The reply hit its length limit",
    message: "Ask the bunny to continue, or narrow the request.",
  },
  message_limit: {
    title: "Message limit reached",
    message: "Keep your message within 8,000 characters and 16 KiB.",
  },
  message_too_long: {
    title: "Message too long",
    message: "Keep your message within 8,000 characters and 16 KiB.",
  },
  conversation_busy: {
    title: "This bunny is still working",
    message: "Wait for the current reply, or queue your message.",
    retryable: true,
  },
  steer_unsupported: {
    title: "This reply can't be redirected",
    message:
      "This kind of run can't change course midway. Stop it and send your message instead.",
  },
  redirect_pending: {
    title: "Already redirecting",
    message:
      "This reply is already being redirected. Your first redirect starts once the reply reaches a safe point.",
  },
  run_finished: {
    title: "The reply already finished",
    message: "Send your message as a new one instead.",
  },
  redirected: {
    title: "Reply redirected",
    message: "You redirected this reply. Your new message started a new turn.",
  },
  message_hidden: {
    title: "That message is hidden",
    message: "Show the hidden messages first, then try again.",
  },
  branch_unavailable: {
    title: "Branching isn't available yet",
    message: "Ask your administrator to finish upgrading Helix Agentspace.",
  },
  branch_unsupported: {
    title: "This conversation can't be branched",
    message: "Only your own chats with a bunny can be branched.",
  },
  restore_unavailable: {
    title: "Restoring isn't available yet",
    message: "Ask your administrator to finish upgrading Helix Agentspace.",
  },
  nothing_to_restore: {
    title: "Nothing to hide",
    message: "There are no messages after this one.",
  },
  restore_changed: {
    title: "The conversation changed",
    message:
      "New messages arrived since you looked. Check what would be hidden and try again.",
  },
  revert_unavailable: {
    title: "These changes can't be reverted",
    message: "Only applied coding changes can be reverted here.",
  },
  revert_changed: {
    title: "The workspace changed",
    message:
      "Files changed since the preview. Check the preview again before reverting.",
  },
  revert_in_progress: {
    title: "Already reverting",
    message: "These changes are already being reverted, or were reverted.",
  },
  // External agents (EXT-01..03)
  authorization_pending: {
    title: "Waiting for approval",
    message:
      "An admin hasn't approved this agent yet. Keep waiting; the code works for ten minutes.",
    retryable: true,
  },
  slow_down: {
    title: "Checking too often",
    message:
      "Wait a little longer between checks. The interval is now five seconds longer.",
    retryable: true,
  },
  expired_token: {
    title: "The pairing code expired",
    message: "Codes last ten minutes. Start pairing again to get a new code.",
  },
  access_denied: {
    title: "Pairing was declined",
    message:
      "An admin declined this agent, or its bunny was removed. Ask your admin, then pair again.",
  },
  invalid_grant: {
    title: "This pairing can't be used",
    message:
      "The device code is unknown or was already used. Start pairing again.",
  },
  pairing_code_invalid: {
    title: "That code doesn't match",
    message:
      "Check the eight letters the agent printed and try again. Codes last ten minutes.",
  },
  pairing_code_expired: {
    title: "That code expired",
    message:
      "Codes last ten minutes. Run the agent's login again for a new code.",
  },
  pairing_code_attempts: {
    title: "Too many wrong codes",
    message: "Wait ten minutes, then enter the code again.",
    retryable: true,
  },
  agent_scope_denied: {
    title: "Not allowed for this agent",
    message:
      "This agent wasn't approved for that. An admin can add the scope on the bunny's page.",
  },
  external_agent_revoked: {
    title: "This agent was disconnected",
    message:
      "Its access was revoked. Pair the agent again to bring it back as a new bunny.",
  },
  external_agents_unavailable: {
    title: "External agents are unavailable",
    message: "Helix Agentspace is starting or stopping. Try again in a moment.",
    retryable: true,
  },
  external_bunny_offline: {
    title: "This bunny is offline",
    message:
      "Its agent isn't connected, so it can't start. Start the agent (agentspace-agent listen), then try again.",
  },
  external_bunny_unsupported: {
    title: "This bunny works from outside",
    message:
      "An external bunny answers in its own direct chats only. Message it directly instead.",
  },
  external_bunny_attachments: {
    title: "Attachments can't be sent here",
    message:
      "External bunnies receive text only. Remove the attachment and send again.",
  },
  external_agent_credential_binding: {
    title: "This secret belongs to an agent",
    message:
      "It signs one external agent's webhooks and can't be used by a connection.",
  },
  webhook_url_invalid: {
    title: "Check the webhook address",
    message:
      "Use a full https:// address without a user name, password or #fragment.",
  },
  webhook_address_refused: {
    title: "That webhook address isn't allowed",
    message:
      "Webhooks can't go to local or private network addresses. Use a public https:// address.",
  },
  delivery_outcome_unknown: {
    title: "Delivery outcome unknown",
    message:
      "The webhook was sent but no answer came back, so it may or may not have arrived. It isn't resent automatically.",
  },
  conversation_archived: {
    title: "This conversation is archived",
    message: "Restore it before sending new messages.",
  },
  attempt_limit: {
    title: "Stopped after several attempts",
    message:
      "The bunny tried this reply three times. Check the error above and try again.",
  },
  timeout: {
    title: "The reply took too long",
    message:
      "The model didn't finish in time. Try again or simplify the request.",
    retryable: true,
  },
  cancelled: {
    title: "Stopped",
    message: "This reply was stopped before it finished.",
  },
  permission_revoked: {
    title: "Access changed",
    message:
      "Your access changed while this was running. Ask an admin if you still need it.",
  },
  runtime_store_missing: {
    title: "Conversation history is missing",
    message:
      "This conversation's history couldn't be found on the server. Contact your admin.",
  },
  runtime_origin_conflict: {
    title: "Opened in another place",
    message: "This conversation is running elsewhere. Reload to continue here.",
  },
  runtime_unavailable: {
    title: "Chat is starting up",
    message: "The chat service isn't ready yet. Try again in a moment.",
    retryable: true,
  },
  chat_unavailable: {
    title: "Chat is unavailable",
    message: "The chat service isn't ready. Try again in a moment.",
    retryable: true,
  },
  approval_unavailable: {
    title: "This approval is no longer open",
    message:
      "It was already answered or expired. Reload to see the latest state.",
  },
  // Sign-in and access
  unauthorized: {
    title: "Sign in to continue",
    message: "Your session ended. Sign in again to continue.",
    action: signIn,
  },
  invalid_credentials: {
    title: "Incorrect email or password",
    message: "Incorrect email or password.",
  },
  authentication_limited: {
    title: "Too many sign-in attempts",
    message: "Too many sign-in attempts. Wait 15 minutes, then try again.",
  },
  csrf_rejected: {
    title: "Your session needs a refresh",
    message: "Reload the page, then try again.",
  },
  request_origin_rejected: {
    title: "Request blocked",
    message:
      "This request came from an unexpected address. Reload Helix Agentspace and try again.",
  },
  forbidden: {
    title: "You don't have access",
    message:
      "You don't have permission to do that. Ask a team admin for access.",
  },
  setup_complete: {
    title: "Setup is already complete",
    message: "This installation is set up. Sign in with your account.",
  },
  // IAM-03: two-step sign-in.
  invalid_mfa_code: {
    title: "That code didn't work",
    message:
      "Enter the current code from your authenticator app, or a recovery code.",
  },
  mfa_challenge_expired: {
    title: "Sign in again",
    message: "This sign-in step expired. Sign in again with your password.",
    action: signIn,
  },
  mfa_required: {
    title: "Two-step sign-in is on",
    message:
      "This account uses two-step sign-in. Sign in from the Helix Agentspace web app.",
  },
  mfa_enrollment_required: {
    title: "Set up two-step sign-in",
    message: "Your team requires two-step sign-in. Set it up to continue.",
  },
  mfa_already_enabled: {
    title: "Two-step sign-in is already on",
    message:
      "Turn it off first if you want to set up a different authenticator.",
  },
  mfa_enrolment_missing: {
    title: "Start setup again",
    message:
      "Start setting up two-step sign-in again, then enter the new code.",
  },
  mfa_required_for_admin: {
    title: "Turn on two-step sign-in first",
    message:
      "Turn on two-step sign-in for your own account before requiring it for the team.",
  },
  mfa_reset_self: {
    title: "Use your own settings",
    message: "To turn off your own two-step sign-in, use Account & security.",
  },
  // IAM-06: password reset.
  reset_link_invalid: {
    title: "This reset link no longer works",
    message:
      "This reset link has expired or was already used. Ask for a new one.",
  },
  reset_link_self: {
    title: "Use your own settings",
    message: "To change your own password, use Account & security.",
  },
  password_reset_unavailable: {
    title: "Email reset isn't set up",
    message:
      "Password reset by email isn't set up here. Ask a team admin for a reset link.",
  },
  password_reset_limited: {
    title: "Too many reset attempts",
    message:
      "Too many password reset attempts. Wait 15 minutes, then try again.",
  },
  password_confirmation: {
    title: "Passwords don't match",
    message: "Enter the same new password twice.",
  },
  invalid_email: {
    title: "Check the email address",
    message: "Enter an email address like name@example.com.",
  },
  current_password_invalid: {
    title: "Current password is incorrect",
    message: "Check your current password and try again.",
  },
  // SET-04: members and invites; IAM-08: team creation.
  invite_invalid: {
    title: "This invite link no longer works",
    message:
      "This invite link has expired, was already used, or was withdrawn. Ask a team admin for a new one.",
  },
  invite_limited: {
    title: "Too many attempts",
    message:
      "Too many attempts with this invite link. Wait 15 minutes, then try again.",
  },
  invite_role_forbidden: {
    title: "Only owners can invite admins",
    message:
      "Only owners can invite admins. Invite them as a member, or ask an owner.",
  },
  invite_already_member: {
    title: "You're already in this team",
    message: "You're already in this team. Switch to it from the team menu.",
  },
  login_taken: {
    title: "That email already has an account",
    message:
      "An account with that email already exists. Sign in with it instead.",
  },
  owner_change_requires_owner: {
    title: "Only owners can do this",
    message:
      "Only an owner can make someone an owner or change an owner's access.",
  },
  last_owner: {
    title: "A team needs an owner",
    message:
      "A team needs at least one owner. Make someone else an owner first.",
  },
  member_remove_self: {
    title: "You can't remove yourself",
    message:
      "You can't remove yourself from the team. Ask another owner or admin to do it.",
  },
  team_creation_disabled: {
    title: "Creating teams is off",
    message:
      "This installation has one team. An operator can allow more teams in the server configuration.",
  },
  // IAM-04: single sign-on.
  local_login_disabled: {
    title: "Use single sign-on",
    message:
      "Your team signs in with single sign-on. Choose your team's sign-in button instead of a password.",
  },
  invite_requires_sso: {
    title: "Use single sign-on",
    message:
      "This team signs in with single sign-on. Use the team's sign-in button instead of creating a password.",
  },
  federation_member_managed: {
    title: "Managed in Workspace",
    message: "Manage this person\u2019s app access and sign-in in Workspace.",
  },
  federation_directory_stale: {
    title: "Workspace verification is overdue",
    message:
      "Agentspace is waiting for Workspace to verify team access. Retry shortly, or ask your operator to check the connection. The local recovery owner can still sign in.",
    retryable: true,
  },
  federation_access_removed: {
    title: "Workspace access removed",
    message:
      "Your Workspace administrator must assign you to this Agentspace application before you can use this team.",
  },
  federation_checkpoint_expired: {
    title: "Directory verification expired",
    message: "Start a new directory reconciliation from Workspace.",
    retryable: true,
  },
  sso_failed: {
    title: "Single sign-on didn't work",
    message:
      "Your identity provider's answer couldn't be verified. Try again, or ask a team admin to check the single sign-on settings.",
  },
  sso_state_invalid: {
    title: "Sign-in expired",
    message:
      "This sign-in started in another tab, expired, or was already used. Start again from the sign-in page.",
  },
  sso_provider_error: {
    title: "Your identity provider stopped the sign-in",
    message:
      "Your identity provider didn't sign you in. Try again, or ask your administrator whether you have access to Helix Agentspace.",
  },
  sso_not_provisioned: {
    title: "No access yet",
    message:
      "Your account hasn't been added to this team. Ask a team admin to add you.",
  },
  sso_access_removed: {
    title: "Access removed",
    message:
      "You were removed from this team. Ask a team admin to restore your membership.",
  },
  sso_limited: {
    title: "Too many attempts",
    message: "Too many sign-in attempts. Wait a minute, then try again.",
    retryable: true,
  },
  sso_provider_unavailable: {
    title: "Sign-in option unavailable",
    message:
      "This sign-in option was turned off or removed. Reload the page to see the current options.",
  },
  sso_provider_unreachable: {
    title: "Identity provider unreachable",
    message:
      "Helix Agentspace couldn't reach your identity provider. Try again in a moment, or sign in with a password if you're an owner.",
    retryable: true,
  },
  sso_owner_required: {
    title: "Only owners can do this",
    message:
      "Only an owner can change who may sign in with a password or which groups make owners.",
  },
  sso_issuer_invalid: {
    title: "Check the issuer URL",
    message:
      "Enter the issuer as an https:// URL, for example https://login.example.com/realms/team. Plain http:// works only for localhost.",
  },
  sso_scopes_invalid: {
    title: "Check the scopes",
    message:
      "Separate scopes with spaces and include openid, for example: openid email profile.",
  },
  sso_group_duplicate: {
    title: "Group listed twice",
    message: "Each group can map to one role. Remove the duplicate row.",
  },
  sso_discovery_failed: {
    title: "Couldn't reach the identity provider",
    message:
      "Helix Agentspace couldn't read the provider's discovery document at the issuer URL. Check the issuer and that the server can reach it.",
  },
  // IAM-05: SCIM provisioning.
  scim_token_limit: {
    title: "Too many SCIM tokens",
    message:
      "This team already has 10 SCIM tokens. Revoke one you no longer use, then create a new one.",
  },
  session_not_found: {
    title: "Session already ended",
    message:
      "That session has already signed out or expired. Refresh the list to see active sessions.",
  },
  invalid_audit_cursor: {
    title: "Audit page expired",
    message: "This page of the audit log is no longer valid. Reload the list.",
  },
  // SHIP-01..05: git remotes, pushes and pull requests.
  remote_url_invalid: {
    title: "That remote address isn't valid",
    message:
      "Use an https:// or ssh:// address (or git@host:owner/repo.git) that names a repository path.",
  },
  remote_url_credentials: {
    title: "Remove the password from the address",
    message:
      "Remote addresses must not contain a user name and password or a token. Save the token as a credential and choose it instead.",
  },
  remote_url_transport: {
    title: "Only https and ssh remotes are allowed",
    message:
      "File paths, plain http, git:// and helper transports such as ext:: are refused. Use an https:// or ssh:// address.",
  },
  remote_private_destination: {
    title: "That remote is on a private network",
    message:
      "Remotes that resolve to private, loopback or link-local addresses are refused. Ask the operator to allow private forges if this one is trusted.",
  },
  remote_name_conflict: {
    title: "A remote with that name exists",
    message:
      "Choose another name for this remote, or remove the old one first.",
  },
  remote_limit: {
    title: "Too many remotes",
    message: "A repository can have up to 10 remotes. Remove one first.",
  },
  remote_credential_kind: {
    title: "That credential doesn't fit this remote",
    message:
      "Https remotes use a token credential and ssh remotes use an SSH private key. Choose a credential of the right kind.",
  },
  remote_unreachable: {
    title: "Couldn't reach the remote",
    message:
      "The remote's host couldn't be reached. Check the address and that the forge is online, then test again.",
    retryable: true,
  },
  remote_auth_failed: {
    title: "The remote refused the credential",
    message:
      "Authentication failed. Rotate the credential on the Secrets tab or choose another one, then test again.",
  },
  remote_repository_not_found: {
    title: "The remote repository wasn't found",
    message:
      "The forge answered, but this repository doesn't exist or the credential can't see it.",
  },
  remote_host_key_changed: {
    title: "The remote's host key changed",
    message:
      "The SSH host key no longer matches the one saved when the remote was first tested. Remove and add the remote again if the change is expected.",
  },
  remote_timeout: {
    title: "The remote took too long",
    message: "The remote didn't answer in time. Try again in a moment.",
    retryable: true,
  },
  remote_not_connected: {
    title: "Test the remote first",
    message:
      "Saved credentials aren't a connection. Run Test connection on the repository page until it passes.",
  },
  push_run_not_reviewed: {
    title: "This run has no reviewed result",
    message:
      "Only a completed run with a reviewed result (applied or not) can be pushed.",
  },
  push_review_changes_requested: {
    title: "The reviewer asked for changes",
    message:
      "The reviewing bunny asked for changes on this run. Start a new run before pushing.",
  },
  push_base_mismatch: {
    title: "The remote changed the files this run edited",
    message:
      "Neither the remote branch nor its default branch has the files this run started from. Start a new run from the current remote state.",
  },
  push_no_changes: {
    title: "Nothing to push",
    message: "This run didn't change any files.",
  },
  push_authorization_mismatch: {
    title: "The push you confirmed has changed",
    message:
      "The remote, branch, expected remote commit or local commit differs from what you confirmed. Review the push again.",
  },
  push_lease_mismatch: {
    title: "Someone else pushed to this branch",
    message:
      "The branch moved since you confirmed the push, so nothing was overwritten. Prepare the push again to see the new state.",
  },
  push_rejected: {
    title: "The remote rejected the push",
    message:
      "The remote refused the branch update (for example a protected branch or a hook on the server).",
  },
  push_outcome_unknown: {
    title: "We don't know if the push finished",
    message:
      "The connection ended before the remote answered. Helix Agentspace checks the remote branch before any retry.",
    retryable: true,
  },
  push_not_retryable: {
    title: "This push can't be started again",
    message:
      "It already finished or was rejected. Prepare a new push to try again.",
  },
  forge_unauthorized: {
    title: "The forge rejected the token",
    message:
      "The forge answered 401. Rotate the API token credential for this remote, then try again.",
  },
  forge_forbidden: {
    title: "The token can't do that",
    message:
      "The forge answered 403. Give the token permission to create pull requests and read checks.",
  },
  forge_not_found: {
    title: "The forge couldn't find the repository",
    message:
      "The forge answered 404. Check the remote address and that the token can see the repository.",
  },
  forge_unprocessable: {
    title: "The forge refused the pull request",
    message:
      "The forge answered 422: the branch may be missing, the base branch may be wrong, or a pull request may already exist.",
  },
  forge_conflict: {
    title: "The forge reported a conflict",
    message:
      "A merge request for this branch may already exist. Refresh to pick it up.",
  },
  forge_unavailable: {
    title: "The forge isn't answering",
    message: "The forge returned an error. Try again in a moment.",
    retryable: true,
  },
  forge_unsupported: {
    title: "Pull requests aren't supported for this remote",
    message:
      "Draft pull requests work with GitHub and GitLab remotes. Other remotes support push only.",
  },
  forge_credential_required: {
    title: "This remote needs an API token",
    message:
      "Pull requests and checks use the forge API. Add a token credential to the remote.",
  },
  forge_outcome_unknown: {
    title: "We don't know if the pull request was opened",
    message:
      "The forge didn't answer in time. Helix Agentspace looks for a pull request on the same branch before trying again.",
    retryable: true,
  },
  pull_request_push_required: {
    title: "Push the branch first",
    message: "A draft pull request opens after the branch push succeeds.",
  },
  pull_request_fix_not_needed: {
    title: "Nothing to fix",
    message:
      "The checks aren't failing and no reviewer asked for changes, so there's nothing for a bunny to fix.",
  },
  pull_request_fix_source_required: {
    title: "Apply the reviewed result first",
    message:
      "A shared PR fix starts from the reviewed changes applied to the project workspace. Apply this result before requesting a fix. Separately published remote worktrees need their source updated first.",
  },
  pull_request_fix_changed: {
    title: "The PR changed",
    message:
      "The source or PR branch no longer matches this fix request. Refresh the PR, update the project source and request a new fix.",
  },
  // NOTE-01/02: notifications and web push.
  notifications_people_only: {
    title: "Notifications are for people",
    message:
      "Notification settings belong to a signed-in person. Sign in to Helix Agentspace in a browser to change them.",
  },
  quiet_hours_invalid: {
    title: "Check your quiet hours",
    message:
      "Quiet hours need a start and an end time that differ, written as hours and minutes.",
  },
  time_zone_invalid: {
    title: "Unknown time zone",
    message: "Choose a time zone from the list, such as Europe/Berlin.",
  },
  push_subscription_invalid: {
    title: "This browser's push details aren't valid",
    message:
      "Turn push off and on again in this browser. If it keeps happening, the browser may not support web push.",
  },
  push_subscription_expired: {
    title: "This device's push has expired",
    message: "Turn push on again in this browser to get a fresh subscription.",
  },
  push_subscription_limit: {
    title: "Too many devices",
    message:
      "You can receive push on up to 10 devices. Remove one you no longer use, then try again.",
  },
  push_endpoint_invalid: {
    title: "This push service isn't allowed",
    message:
      "Helix Agentspace only sends push to public HTTPS push services. Try another browser.",
  },
  push_payload_too_large: {
    title: "Notification too large",
    message:
      "This notification was too long to push. It is still in Helix Agentspace.",
  },
  push_key_unavailable: {
    title: "The push key changed",
    message:
      "The team's web push key was replaced or removed. Turn push on again on each device.",
  },
  push_destination_unreachable: {
    title: "Couldn't reach the push service",
    message:
      "The browser's push service didn't answer, so nothing was sent. Helix Agentspace will show this notification in the app.",
    retryable: true,
  },
  push_private_destination: {
    title: "Push service address refused",
    message:
      "The push service resolved to a private network address, so Helix Agentspace refused to send to it.",
  },
  web_push_outcome_unknown: {
    title: "Push may not have arrived",
    message:
      "The connection dropped after sending, so Helix Agentspace can't tell whether this device got it. It is checked once more without showing it twice.",
  },
  push_subscription_gone: {
    title: "Device removed",
    message:
      "The browser no longer accepts push for this device, so Helix Agentspace removed it. Turn push on again there if you want it.",
  },
  push_service_busy: {
    title: "Push service busy",
    message:
      "The push service asked Helix Agentspace to wait. It tries again shortly, up to three times.",
    retryable: true,
  },
  web_push_rejected: {
    title: "Push service refused",
    message:
      "The push service refused this notification. Turn push off and on again on that device.",
  },
  channel_unavailable: {
    title: "Channel not set up",
    message:
      "This channel isn't available on this server yet, so the notification stayed in Helix Agentspace.",
  },
  recipient_removed: {
    title: "Not sent",
    message:
      "The person this was for is no longer in the team, so it wasn't sent.",
  },
  dispatch_outcome_unknown: {
    title: "Delivery outcome unknown",
    message:
      "Helix Agentspace stopped while sending this, so it can't tell whether it arrived. It is never sent again blindly.",
  },
  // NOTE-03..05: email, digests and linked Slack or Telegram accounts.
  digest_schedule_invalid: {
    title: "Check your digest time",
    message: "Choose when your digest arrives as hours and minutes.",
  },
  email_not_configured: {
    title: "Email isn't set up here",
    message:
      "This server doesn't send email. Ask a team admin to set up outgoing email.",
  },
  email_address_rejected: {
    title: "Your email address was refused",
    message:
      "The mail server refused your address for good, so Helix Agentspace stopped emailing it. Check the address in Account, then choose Try email again.",
    action: {
      label: "Open notification settings",
      route: "#/settings/me/notifications",
    },
  },
  email_address_failing: {
    title: "Not emailed",
    message:
      "Your address was refused before, so Helix Agentspace didn't try again. Check it, then choose Try email again in your notification settings.",
  },
  email_address_changed: {
    title: "Not emailed",
    message:
      "Your email address changed after this was queued, so it wasn't sent to the old one.",
  },
  email_rejected: {
    title: "Email refused",
    message:
      "The mail server refused this email. It is still in Helix Agentspace. If it keeps happening, ask a team admin to check the email setup.",
  },
  email_server_busy: {
    title: "Mail server busy",
    message:
      "The mail server asked Helix Agentspace to try later. It tries again shortly, up to three times.",
    retryable: true,
  },
  email_server_unreachable: {
    title: "Couldn't reach the mail server",
    message:
      "Nothing was sent. Helix Agentspace tries again shortly, up to three times.",
    retryable: true,
  },
  email_outcome_unknown: {
    title: "Email may not have arrived",
    message:
      "The connection to the mail server dropped after the email was handed over, so Helix Agentspace can't tell whether it arrived. It isn't sent again.",
  },
  email_invalid: {
    title: "Email couldn't be written",
    message:
      "This notification couldn't be turned into an email. It is still in Helix Agentspace.",
  },
  channel_link_unavailable: {
    title: "Can't link through that bot",
    message:
      "That Slack or Telegram bot isn't enabled and checked. Ask a team admin to check it in Settings, Messaging.",
  },
  channel_link_gone: {
    title: "Account no longer linked",
    message:
      "Your Slack or Telegram account was unlinked, so this wasn't sent there. Link it again in your notification settings.",
  },
  channel_outcome_unknown: {
    title: "Message may not have arrived",
    message:
      "Slack or Telegram didn't confirm this message, so Helix Agentspace can't tell whether it arrived. It isn't sent again.",
  },
  uncertain_provider_response: {
    title: "Message may not have arrived",
    message:
      "The platform didn't answer clearly, so Helix Agentspace can't tell whether the message arrived. It isn't sent again.",
  },
  connection_unchecked: {
    title: "Bot not checked",
    message:
      "This bot hasn't passed its connection check. Ask a team admin to check it in Settings, Messaging.",
  },
  // Messaging channels without a public URL, Discord, Matrix and email (CHAN)
  webhook_not_used: {
    title: "This channel doesn't take webhooks",
    message:
      "This channel receives by polling or a socket, so its webhook address is turned off. Remove the webhook on the platform.",
  },
  invalid_receive_mode: {
    title: "That platform can't receive this way",
    message:
      "Telegram receives by webhook or long polling, Slack by webhook or Socket Mode, Discord by its Gateway, Matrix by sync and email by a signed webhook.",
  },
  credential_not_used: {
    title: "That secret isn't used here",
    message:
      "This platform and receive mode don't use a webhook secret. Leave it out.",
  },
  invalid_homeserver: {
    title: "Check the homeserver address",
    message:
      "Enter the Matrix homeserver's HTTPS address, like https://matrix.example.org.",
  },
  email_reply_only: {
    title: "Email channels only reply",
    message:
      "An email channel answers mail it receives, in the same thread. It can't start a conversation or carry scheduled messages.",
  },
  discord_message_too_long: {
    title: "Too long for Discord",
    message: "Discord takes at most 2,000 characters in one message.",
  },
  discord_message_content_intent: {
    title: "Turn on the Message Content intent",
    message:
      "Discord sends this bot empty messages until the Message Content intent is on. Turn it on in the Discord developer portal, then verify again.",
    action: { label: "Open Messaging", route: "#/settings/team/messaging" },
  },
  discord_intents_disallowed: {
    title: "Discord refused the bot's intents",
    message:
      "Turn on the Message Content intent for this bot in the Discord developer portal. Helix Agentspace tries again in a minute.",
  },
  discord_invalid_intents: {
    title: "Discord refused the bot's intents",
    message:
      "Discord didn't accept the requested intents. Check the bot's settings in the Discord developer portal.",
  },
  matrix_room_encrypted: {
    title: "Encrypted Matrix room",
    message:
      "This room uses end-to-end encryption, which Helix Agentspace can't read or write. Use a room without encryption for this channel.",
  },
  matrix_room_not_joined: {
    title: "The bot isn't in that room",
    message:
      "Invite the Matrix bot account to the room and accept the invite, then verify again.",
  },
  channel_private_destination: {
    title: "Private address refused",
    message:
      "That service is on a private network. Ask the operator to allow private networks for messaging if this is intended.",
  },
  channel_insecure_url: {
    title: "Secure address needed",
    message:
      "Messaging services must use HTTPS or WSS. Plain HTTP is only allowed on a private network the operator allowed.",
  },
  channel_unreachable: {
    title: "Service unreachable",
    message:
      "Helix Agentspace couldn't find that service's address. Check it and try again.",
    retryable: true,
  },
  channel_response_too_large: {
    title: "Answer too large",
    message:
      "The service answered with more data than Helix Agentspace accepts.",
  },
  telegram_webhook_active: {
    title: "A Telegram webhook is set",
    message:
      "Telegram refuses polling while the bot has a webhook. Remove it with deleteWebhook, or use a webhook channel instead.",
  },
  invalid_app_token: {
    title: "Slack app-level token not accepted",
    message:
      "Socket Mode needs an app-level token (xapp-) with connections:write, kept as a bearer token in the vault.",
  },
  invalid_bot_credential: {
    title: "Bot token not accepted",
    message:
      "The platform refused this bot token, or it isn't shaped like one. Replace the vault entry with a new channel.",
  },
  email_unknown_sender: {
    title: "Sender not allowed",
    message:
      "Only allowed addresses that belong to team members are answered. The sender got a short note saying so.",
  },
  email_not_this_inbox: {
    title: "Not for this inbox",
    message: "The email wasn't addressed to this channel's inbox.",
  },
  email_unreadable: {
    title: "Email couldn't be read",
    message: "The mail provider's message was missing its sender, ID or text.",
  },
  gateway_closed: {
    title: "Connection closed",
    message:
      "The platform closed the connection. Helix Agentspace reconnects shortly.",
    retryable: true,
  },
  socket_closed: {
    title: "Connection closed",
    message:
      "The platform closed the connection. Helix Agentspace reconnects shortly.",
    retryable: true,
  },
  socket_error: {
    title: "Connection failed",
    message:
      "The connection to the platform failed. Helix Agentspace tries again shortly.",
    retryable: true,
  },
  digest_not_sent: {
    title: "Not in a digest",
    message:
      "This was held for a digest that never went out (digests are off, or no channel could reach you). It is still in Helix Agentspace.",
  },
  // SHIP-06..08: review, worktree lifecycle and "Build it"
  review_not_ready: {
    title: "No reviewed result yet",
    message:
      "This run hasn't finished with a frozen result. Wait for it to complete, then review it.",
  },
  review_changed: {
    title: "The result changed",
    message:
      "This run's reviewed result changed. Reload the review and mark the files again.",
  },
  invalid_reviewer: {
    title: "Choose another reviewer",
    message:
      "The reviewer must be an active bunny other than the one that wrote the change.",
  },
  review_input_limit: {
    title: "The result is too large for automatic review",
    message:
      "The complete changed files and recorded command output exceed the review limit. Inspect the saved result and split the work into smaller changes. No review was started and no evidence was omitted to make it fit.",
  },
  coding_worker_unavailable: {
    title: "Coding isn't available",
    message:
      "This server has no coding worker connected. Start the coding worker, then try again.",
  },
  conflict_preview_not_repository: {
    title: "No conflict preview",
    message:
      "This run didn't work on a repository branch, so there is nothing to merge-check.",
  },
  conflict_preview_not_ready: {
    title: "The result isn't frozen yet",
    message:
      "A conflict preview needs the run's frozen branch. Try again once the run is ready for review.",
  },
  conflict_preview_mismatch: {
    title: "The branch moved",
    message:
      "The run's branch doesn't match its frozen result. Reload the run before applying it.",
  },
  worktree_unavailable: {
    title: "The worktree can't be reached",
    message:
      "The executor didn't answer for this worktree. Check that it is running, then try again.",
    retryable: true,
  },
  workspace_unavailable: {
    title: "The workspace isn't available",
    message:
      "This workspace isn't available: it is still preparing, or it failed to set up.",
  },
  disk_not_measured: {
    title: "Not measured yet",
    message: "Run Measure disk use to read how much space this worktree takes.",
  },
  worktree_dirty: {
    title: "The worktree has uncommitted changes",
    message:
      "It was not archived or removed. Commit, move or discard the changes; the archive is tried again daily.",
  },
  worktree_archive_mismatch: {
    title: "The archive didn't match",
    message:
      "The executor answered for a different branch head, so nothing was recorded. It is tried again later.",
  },
  build_item_closed: {
    title: "This item is closed",
    message: "Reopen the work item to build it.",
  },
  build_no_repository: {
    title: "No repository to build in",
    message:
      "Put the item in a project whose workspace is a repository worktree, then Build it.",
  },
  build_workspace_unavailable: {
    title: "The project's worktree isn't active",
    message: "Wait for the worktree to finish preparing, or create it again.",
  },
  build_no_remote: {
    title: "The repository has no remote",
    message:
      "Add the forge repository as a remote on the repository page, then Build it.",
  },
  build_no_reviewer: {
    title: "No reviewing bunny",
    message:
      "Build it asks a second bunny to review the change. Create another bunny first.",
  },
  build_unavailable: {
    title: "Build it isn't available",
    message:
      "Something this item needs is missing. Reload the item to see what.",
  },
  build_already_running: {
    title: "A build is already running",
    message:
      "This item already has a build in progress. Stop it or wait for it to finish.",
  },
  build_not_resumable: {
    title: "This build can't continue",
    message: "It failed or finished. Start Build it again for a fresh attempt.",
  },
  build_session_ended: {
    title: "Your sign-in ended",
    message:
      "The build stopped because your session ended or your access changed. Resume it while signed in.",
  },
  build_no_tests: {
    title: "No tests ran",
    message:
      "The bunny ran no command, so nothing shows the change works. Review it, then resume to continue without test receipts.",
  },
  build_stopped_by_person: {
    title: "Stopped",
    message:
      "Someone stopped this build. Resume it to continue from this step.",
  },
  build_no_changes: {
    title: "No changes",
    message:
      "The bunny finished without changing any file, so there is nothing to push.",
  },
  build_tests_failed: {
    title: "Tests failed",
    message:
      "A test command exited with an error, so the build stopped before review and nothing was pushed. Fix the change and build again.",
  },
  build_review_changes_requested: {
    title: "The reviewer asked for changes",
    message: "Nothing was pushed. Address the review, then build again.",
  },
  build_review_failed: {
    title: "The review didn't finish",
    message:
      "The reviewing bunny didn't return a verdict. Build again, or review the run yourself.",
  },
  build_branch_exists: {
    title: "The branch already exists",
    message:
      "Build it only creates new branches. Nothing was pushed; build again with another branch name.",
  },
  // Common request failures
  not_found: {
    title: "Not found",
    message: "This item no longer exists, or you don't have access to it.",
  },
  conflict: {
    title: "Something changed",
    message: "This changed since you opened it. Reload and try again.",
  },
  revision_conflict: {
    title: "Someone else changed this",
    message:
      "This changed since you opened it. Reload to see the latest version, then try again.",
  },
  revision_changed: {
    title: "Someone else changed this",
    message:
      "This changed since you opened it. Reload to see the latest version, then try again.",
  },
  idempotency_conflict: {
    title: "Duplicate request",
    message:
      "A different request already used this identifier. Reload and try again.",
  },
  invalid_precondition: {
    title: "Request not accepted",
    message:
      "The expected revision in this request isn't usable. Reload and try again.",
  },
  invalid_idempotency_key: {
    title: "Request not accepted",
    message:
      "The request identifier in this request isn't usable. Reload and try again.",
  },
  invalid_request: {
    title: "Request not accepted",
    message: "Some details weren't valid. Check the form and try again.",
  },
  invalid: {
    title: "Request not accepted",
    message: "Some details weren't valid. Check the form and try again.",
  },
  invalid_response: {
    title: "Unexpected response",
    message:
      "The server sent a response Helix Agentspace couldn't read. Reload and try again.",
    retryable: true,
  },
  body_too_large: {
    title: "Too much data",
    message:
      "This request is larger than the server accepts. Send less at once.",
  },
  rate_limited: {
    title: "Too many requests",
    message:
      "You're sending requests faster than Helix Agentspace allows. Wait a moment, then try again.",
    retryable: true,
  },
  internal_error: {
    title: "Something went wrong",
    message:
      "The server couldn't complete this request. Try again; if it keeps failing, share the request ID with your admin.",
    retryable: true,
  },
  network_error: {
    title: "Can't reach Helix Agentspace",
    message: "Check your connection, then try again.",
    retryable: true,
  },
  state_unavailable: {
    title: "Helix Agentspace is unavailable",
    message: "The server isn't ready. Try again in a moment.",
    retryable: true,
  },
  provider_is_default: {
    title: "This provider supplies the default model",
    message:
      "Choose a default model from another provider before removing this one.",
  },
  provider_api_key_required: {
    title: "API key required",
    message: "Enter the provider's API key to connect it.",
  },
  dependency_cycle: {
    title: "Circular dependency",
    message:
      "This work would depend on itself through other work. Remove one of the dependencies.",
  },
  goal_paused: {
    title: "This goal is paused",
    message: "Resume the goal before it can start more work.",
  },
  google_missing_scopes: {
    title: "Google access is incomplete",
    message:
      "Reconnect your Google account and allow every requested permission.",
  },
  main_self_modification_denied: {
    title: "Helix can't change itself",
    message:
      "The main bunny can't edit its own access or instructions. Ask a team admin to make the change.",
  },
  invalid_cursor: {
    title: "That page link is out of date",
    message: "Reload the list to start from the first page.",
  },
  attention_snooze_invalid: {
    title: "Pick a later time",
    message: "Snooze until a time in the next 31 days.",
  },
  work_needs_attention: {
    title: "This work needs attention first",
    message:
      "Resolve its pending approval or unknown outcome before changing its state.",
  },
  workspace_work_managed: {
    title: "Workspace owns this request",
    message:
      "Inspect its source, approval and existing run. You can cancel pending work or accept a delivered result, but cannot reassign, share or restart this request from the board.",
  },
  workspace_work_stopped: {
    title: "This Workspace request was stopped",
    message:
      "No further model tools or reply sends are allowed. Inspect the original delivery receipt if its outcome is unknown.",
  },
  // HOOK-01..03: webhook filters, triggers, forge webhooks and setup recipes.
  invalid_webhook_filters: {
    title: "Check the webhook filters",
    message:
      "Filters belong to signed webhook automations. Use up to 10, each a JSON Pointer such as /action (or empty for the whole event) and the exact JSON value expected there.",
  },
  event_conflict: {
    title: "That event id was already used",
    message:
      "An event with this id arrived before with different content. Send a new event id for a new event.",
  },
  invalid_trigger: {
    title: "Check the trigger",
    message:
      "Pull request and issue triggers need a GitHub or GitLab remote (and a label for issues); credential expiry needs a connection and 1\u201390 days.",
  },
  trigger_remote_unavailable: {
    title: "That remote can't trigger automations",
    message:
      "Choose an active GitHub or GitLab remote. Add a forge webhook on its repository so events arrive at once.",
  },
  trigger_connection_unavailable: {
    title: "That connection isn't available",
    message: "It may have been deleted. Choose another connection.",
  },
  trigger_limit: {
    title: "Too many triggers",
    message: "An automation can have up to 20 triggers. Remove one first.",
  },
  forge_webhook_unsupported: {
    title: "This remote can't send webhooks here",
    message: "Forge webhooks work with GitHub and GitLab remotes.",
  },
  forge_webhook_secret_kind: {
    title: "Choose a webhook signing secret",
    message:
      "Forge webhooks are verified with a credential of the webhook signing secret kind. Create one under Connections \u203A Secrets.",
    action: { label: "Open secrets", route: "#/connections/secrets" },
  },
  forge_webhook_exists: {
    title: "This remote already has a webhook",
    message: "Remove the existing forge webhook before adding another.",
  },
  invalid_recipe: {
    title: "This recipe can't be read",
    message:
      "Check its JSON: a slug, name, description, connection (name and target), credential (kind, name, instructions), grants and verification.",
  },
  recipe_connection_unsupported: {
    title: "This kind of connection can't come from a recipe",
    message:
      "Recipes set up webhook, MCP over HTTPS, SSH and Kubernetes targets without coding profiles. Set this one up by hand.",
  },
  recipe_digest_mismatch: {
    title: "The recipe changed",
    message: "Review it again, then use the version you reviewed.",
  },
  recipe_revoked: {
    title: "This recipe was revoked",
    message: "It can't be used or updated. Import a new recipe instead.",
  },
  recipe_limit: {
    title: "Too many recipes",
    message: "A team can keep up to 100 recipes.",
  },
  recipe_run_closed: {
    title: "This setup is finished",
    message:
      "It was completed or cancelled. Use the recipe again to start over.",
  },
  recipe_step_out_of_order: {
    title: "Finish the earlier step first",
    message: "Recipe steps run in order. Complete the next step shown.",
  },
  recipe_grant_confirmation_required: {
    title: "Confirm the grant",
    message:
      "Choose the bunny and confirm that it may use this connection. Nothing is granted until you do.",
  },
  recipe_credential_required: {
    title: "Add the credential",
    message: "Paste the credential value, or choose an existing credential.",
  },
  recipe_connection_conflict: {
    title: "A different connection has this name",
    message:
      "A connection with this name points somewhere else. It was left unchanged; rename or remove it, then try this step again.",
  },
  recipe_target_changed: {
    title: "The connection no longer matches the recipe",
    message:
      "Its target was changed after it was set up. Check the connection, then try again.",
  },
  // FLOW-02: waiting reasons.
  wait_unavailable: {
    title: "This work can't wait now",
    message:
      "Only agent work that is queued or waiting on prerequisites can be put on hold. Start it first, or wait until it finishes.",
  },
  already_waiting: {
    title: "This work is already waiting",
    message: "Resume or let the current wait end before setting another.",
  },
  project_task_waiting: {
    title: "Earlier shared work is still active",
    message:
      "Wait for the preceding request to finish or be stopped before claiming this one.",
  },
  project_task_stopped: {
    title: "This request no longer accepts work",
    message:
      "Read its current receipt. Stop host execution; an uncertain or stopped assignment must not be launched again.",
  },
  external_report_limit: {
    title: "This request has enough progress reports",
    message:
      "Shared work accepts 99 progress or question reports and one final result, error or stopped report. Send a final report or continue in a new human-addressed request.",
  },
  question_open: {
    title: "A question is already waiting",
    message:
      "Wait for the controller's answer before asking another question on this request.",
  },
  // FLOW-06: questions from bunnies.
  question_closed: {
    title: "That question is already settled",
    message:
      "It was answered, or its conversation closed. Refresh Needs you to see what still needs you.",
  },
  question_limit: {
    title: "Too many questions at once",
    message:
      "A bunny can leave at most three questions in one reply. Answer those first.",
  },
  wait_beyond_authority: {
    title: "That wakeup is too late",
    message:
      "The task's permission to run ends before then. Choose an earlier time; waiting never extends its permission.",
  },
  wait_target_required: {
    title: "Say what it waits for",
    message: "Add a note or choose who or what this work is waiting on.",
  },
  not_waiting: {
    title: "This work isn't waiting",
    message: "Reload the board to see its current state.",
  },
  wait_not_resumable: {
    title: "This wait ends on its own",
    message:
      "Work waiting for a workspace, a prerequisite or an approval continues when that is done.",
  },
  reservation_not_uncertain: {
    title: "Only an uncertain run's workspace can be released",
    message:
      "A running task gives its workspace back when it finishes. Release only a run whose outcome is unknown, after checking it stopped.",
  },
  no_reservation: {
    title: "No workspace is reserved",
    message: "This run no longer holds a workspace. Reload the board.",
  },
  // LEARN-01..04: skill intake, Try, drafts, evaluations and memory expiry.
  skill_path_traversal: {
    title: "A file path leaves the skill folder",
    message:
      "A path in this skill points outside its folder, is absolute or is a link. Keep every file inside the skill's folder and try again.",
  },
  skill_case_collision: {
    title: "Two files differ only by capital letters",
    message:
      "Two paths in this skill are the same apart from upper and lower case. Rename one so each path is unique.",
  },
  skill_secret_file: {
    title: "This skill looks like it holds a secret",
    message:
      "A file is named like a key or credentials file, or contains something shaped like a token. Remove it, keep secrets in Connections, and try again.",
  },
  skill_file_too_large: {
    title: "A file is too long",
    message:
      "Each file in a skill can hold at most 4,000 characters. Shorten it or split it into reference files.",
  },
  skill_archive_too_large: {
    title: "The zip is too large",
    message: "A skill folder can be at most 512 KB zipped. Remove large files.",
  },
  skill_archive_too_many_files: {
    title: "The skill has too many files",
    message:
      "A skill can have SKILL.md and up to 15 reference files. Remove some files.",
  },
  skill_archive_bomb: {
    title: "The zip expands too much",
    message:
      "This zip unpacks to far more than it holds, or past 512 KB in total. Zip the skill's text files again without extras.",
  },
  skill_archive_invalid: {
    title: "That isn't a readable zip",
    message:
      "The file couldn't be read as a zip. Zip the skill folder again and upload it.",
  },
  skill_archive_encrypted: {
    title: "The zip is password-protected",
    message: "Upload a zip without a password.",
  },
  skill_archive_unsupported: {
    title: "The zip uses an unsupported format",
    message:
      "Only stored or deflated zip entries can be read. Zip the folder again with your system's zip tool.",
  },
  skill_file_not_text: {
    title: "A file isn't text",
    message:
      "Skills hold text files only (UTF-8). Remove images, binaries and other non-text files.",
  },
  skill_md_missing: {
    title: "SKILL.md is missing",
    message: "Put a SKILL.md at the top of the skill's folder and try again.",
  },
  skill_manifest_mismatch: {
    title: "The export doesn't match its manifest",
    message:
      "A file changed after this skill was exported, so its digests no longer match. Export it again, or remove manifest.json to import the files as they are.",
  },
  skill_export_extension: {
    title: "Only skills can be exported here",
    message:
      "This version belongs to an extension package, which is exported from its package page.",
  },
  skill_export_too_large: {
    title: "This skill is too long to export",
    message:
      "Adding its name and description would pass 4,000 characters. Shorten the instructions, then export.",
  },
  trial_model_failed: {
    title: "The trial didn't get a reply",
    message:
      "The model didn't answer this try. Check the model connection, then try again.",
    retryable: true,
  },
  trial_turn_limit: {
    title: "This trial is long enough",
    message: "A trial holds at most 20 turns. Start over to try again.",
  },
  run_not_completed: {
    title: "Only finished replies can be marked",
    message:
      "Mark a reply \u201CThis worked\u201D once its run has completed successfully.",
  },
  skill_draft_closed: {
    title: "This draft was already decided",
    message:
      "It has been published or rejected. Reload Drafts to see where it is.",
  },
  evaluation_case_limit: {
    title: "Too many evaluation cases",
    message: "A skill can have up to 20 cases. Delete one before adding more.",
  },
  evaluation_cases_required: {
    title: "Add a case first",
    message:
      "Evaluations need at least one case: an input and what a good reply looks like.",
  },
  memory_expiry_invalid: {
    title: "Choose another expiry date",
    message: "Pick a date within the next ten years, or leave it empty.",
  },
  memory_expired: {
    title: "This memory has expired",
    message:
      "It is left out of runs until someone confirms it. Confirm it in Needs you or edit its expiry.",
  },
  knowledge_source_expired: {
    title: "This source has expired",
    message:
      "Its memory or note passed its expiry date. Confirm it in Needs you to use it again.",
  },
  // FLOW-03: readiness.
  engine_probe_unavailable: {
    title: "Readiness couldn't be checked",
    message:
      "The coding worker didn't answer its health check. Check that it is running, then check again.",
    retryable: true,
  },
  // LIB-01..03: conversation files, project artifacts and collections.
  conversation_files_denied: {
    title: "These files are private",
    message:
      "Only the person who started this chat can see its files. Open one of your own chats.",
  },
  conversation_files_revoked: {
    title: "This chat's project access changed",
    message:
      "The bunny's membership in the project changed, so this chat's files are closed. Open the project to check its bunnies.",
  },
  project_library_denied: {
    title: "Sign in to see project files",
    message: "Project artifacts and collections are available to people only.",
  },
  project_library_write_denied: {
    title: "You can't change this project's records",
    message:
      "You can read this project. Ask its owner or a team admin for write access to change records.",
  },
  project_library_manage_denied: {
    title: "Only admins change this",
    message:
      "Collections and retention are project settings. Ask a team owner or admin.",
  },
  artifact_expired: {
    title: "This artifact has expired",
    message:
      "It is older than the project's retention for its kind. A team admin can keep this kind longer in Artifacts.",
  },
  retention_revision_conflict: {
    title: "Retention changed",
    message:
      "Someone else changed this retention rule. Reload Artifacts and try again.",
  },
  invalid_collection_request: {
    title: "Check the collection details",
    message:
      "A name, field names in lowercase letters, digits and underscores, and a type for each field are needed.",
  },
  collection_field_limit: {
    title: "Too many fields",
    message: "A collection has between 1 and 32 fields.",
  },
  collection_field_duplicate: {
    title: "Two fields have the same name",
    message: "Give each field its own name.",
  },
  collection_field_invalid: {
    title: "Check the field options",
    message:
      "Choice fields need a list of different options; other field types have none.",
  },
  collection_field_unknown: {
    title: "That field isn't in the collection",
    message: "Use only the fields the collection defines.",
  },
  collection_value_invalid: {
    title: "A value doesn't fit its field",
    message:
      "Check each value's type: numbers, whole numbers, yes or no, dates as YYYY-MM-DD, or one of a choice field's options.",
  },
  collection_value_required: {
    title: "A required field is empty",
    message: "Fill in every required field.",
  },
  collection_record_too_large: {
    title: "This record is too large",
    message: "A record holds at most 16 KB. Shorten its text fields.",
  },
  collection_filter_invalid: {
    title: "That filter doesn't fit",
    message:
      "Filter on a field of the collection with a value of the field's type. Contains works on text fields.",
  },
  collection_request_conflict: {
    title: "This request was already used",
    message:
      "The same request id was used for a different change. Start the change again.",
  },
  collection_limit: {
    title: "Collection limit reached",
    message:
      "A project has at most 50 collections. Delete one you no longer use.",
  },
  collection_name_taken: {
    title: "That name is taken",
    message:
      "Another collection in this project has this name. Choose another.",
  },
  collection_revision_conflict: {
    title: "The collection changed",
    message: "Reload the collection and try again.",
  },
  collection_record_revision_conflict: {
    title: "The record changed",
    message:
      "Someone changed this record since you opened it. Reload it, then make your change again.",
  },
  collection_record_limit: {
    title: "Record limit reached",
    message:
      "A collection holds at most 5,000 records. Delete records you no longer need.",
  },
  collection_role_denied: {
    title: "The bunny's role doesn't allow this",
    message:
      "Readers read collections, proposers also add records, and doers can change and delete them.",
  },
  // CONV-05: project checkpoints.
  project_checkpoint_conflict: {
    title: "The checkpoint changed",
    message:
      "Someone else saved a newer checkpoint first. Reload it, then make your change again.",
    retryable: true,
  },
  project_checkpoint_sources_changed: {
    title: "New messages arrived",
    message:
      "The project's messages changed since they were read. Read the sources again and write the checkpoint against them.",
    retryable: true,
  },
  project_checkpoint_source_invalid: {
    title: "A source isn't part of this checkpoint",
    message:
      "Every entry must cite at least one of the project messages this checkpoint covers, and no revoked message.",
  },
  project_checkpoint_too_large: {
    title: "The checkpoint is too long",
    message:
      "Keep it to 20 entries of each kind, 400 characters and 8 sources per entry, and 8,000 characters in all.",
  },
  project_checkpoint_empty: {
    title: "The checkpoint is empty",
    message:
      "Add at least one decision, fact or open question, or delete the checkpoint instead.",
  },
  project_checkpoint_limit: {
    title: "Too many checkpoint revisions",
    message:
      "This project has reached its checkpoint revision limit. Delete the checkpoint to start a new one.",
  },
  project_checkpoint_pending: {
    title: "A checkpoint is already being written",
    message:
      "Wait for the current checkpoint task to finish, or cancel it on the Tasks view.",
    retryable: true,
  },
  project_checkpoint_nothing_new: {
    title: "Nothing new to summarise",
    message:
      "Every shared message is already covered by the checkpoint. Post more before asking for another.",
  },
  project_checkpoint_no_member: {
    title: "No bunny can write the checkpoint",
    message: "Add an active bunny to the project, then ask again.",
  },
  project_checkpoint_task_required: {
    title: "Only a checkpoint task can do this",
    message:
      "Checkpoint sources are read and written only by the task a person or the size threshold asked for.",
  },
  // ENG-L1: live qualification.
  remote_engine_unqualified: {
    title: "This engine didn't pass its qualification",
    message:
      "Its last live qualification failed, or its files changed since it passed. Fix the engine and run scripts/qualify-engine.mjs again.",
    action: { label: "Open Nodes", route: "#/connections/nodes" },
  },
  // ENG-L3: the node registry and placement.
  node_not_found: {
    title: "That node isn't available",
    message:
      "It may have been deleted, or it isn't a coding node. Choose another from Nodes.",
    action: { label: "Open Nodes", route: "#/connections/nodes" },
  },
  node_not_coding: {
    title: "This connection isn't a coding node",
    message:
      "Only SSH and Kubernetes targets with a coding profile can be registered as nodes.",
  },
  node_registration_stale: {
    title: "The node changed since it was registered",
    message:
      "Its connection was edited or its credential rotated. Register the node again so heartbeats use the new version.",
    action: { label: "Open Nodes", route: "#/connections/nodes" },
  },
  node_revision_conflict: {
    title: "Someone else changed this node",
    message: "Reload the node and make your change again.",
  },
  node_revoked: {
    title: "This node was revoked",
    message:
      "It takes no new work. Runs already on it are not moved. Register it again to use it.",
    action: { label: "Open Nodes", route: "#/connections/nodes" },
  },
  node_labels_unmatched: {
    title: "The node doesn't have the required labels",
    message:
      "Choose a node that carries every required label, or change the node's labels in Nodes.",
    action: { label: "Open Nodes", route: "#/connections/nodes" },
  },
  node_at_capacity: {
    title: "The node is full",
    message:
      "It is running as many runs as its capacity allows. Wait for one to finish, or raise its capacity in Nodes.",
    retryable: true,
  },
  node_placement_unavailable: {
    title: "No node can take this run",
    message:
      "No online, registered node with the required labels has a free slot that this bunny may use. Check Nodes and the bunny's connection grants.",
    action: { label: "Open Nodes", route: "#/connections/nodes" },
    retryable: true,
  },
  // BOT-01..03: drafts, access, clone, templates, import and specialists.
  bunny_draft_changed: {
    title: "The draft changed",
    message:
      "Someone saved this bunny's draft after you opened it. Reload the bunny, check the draft, then try again.",
  },
  bunny_draft_missing: {
    title: "There is no draft",
    message:
      "This bunny has no unpublished changes. Reload the bunny to see its published version.",
  },
  bunny_published_changed: {
    title: "A newer version was published",
    message:
      "This bunny was published again after you loaded it. Reload, review the draft against the new version, then publish.",
  },
  bunny_external: {
    title: "Not available for external bunnies",
    message:
      "An external bunny runs outside Helix Agentspace, so it has no draft, clone or template here. Manage it from its pairing page.",
  },
  bunny_retired: {
    title: "This specialist is retired",
    message:
      "Its goal has ended. Its conversations and history stay readable, but it can't be changed or chatted with. Clone it to keep working with it.",
  },
  bunny_version_changed: {
    title: "A newer version was published",
    message:
      "The bunny was published again while you were looking. Reload the conversation and accept the latest version.",
  },
  bunny_import_schema: {
    title: "This file is from another version",
    message:
      "The configuration file uses a schema this server doesn't read. Export the bunny again from a matching version of Helix Agentspace.",
  },
  bunny_import_invalid: {
    title: "This isn't a bunny configuration",
    message:
      "Choose a file exported with Export configuration on a bunny's page.",
  },
  bunny_import_changed: {
    title: "Review the import again",
    message:
      "Something it depends on changed since you reviewed it, so nothing was imported. Review the file again, then import.",
  },
  bunny_slug_taken: {
    title: "That handle is taken",
    message:
      "Another bunny already uses this handle. Choose a different handle and try again.",
  },
  bunny_template_exists: {
    title: "That template handle is taken",
    message:
      "A template with this handle already exists. Choose a different handle.",
  },
  bunny_template_missing: {
    title: "Template not found",
    message:
      "This template was deleted or never existed. Choose another template.",
  },
  bunny_access_owner: {
    title: "The owner always has access",
    message: "A bunny's owner manages it. Choose someone else.",
  },
  bunny_manager_role: {
    title: "Viewers can't manage bunnies",
    message:
      "This person has read-only access to the team. Add them to the audience, or ask an admin to change their team role.",
  },
  bunny_member_unknown: {
    title: "Not in this team",
    message: "Choose someone who is an active member of this team.",
  },
  bunny_skill_unavailable: {
    title: "That skill version isn't available",
    message:
      "The skill version was not found in this team's library. Reload the skills list and choose again.",
  },
  bunny_skill_limit: {
    title: "Too many skills",
    message:
      "A bunny can have up to 32 active skills. Remove one before adding another.",
  },
  specialist_exceeds_grant: {
    title: "More than the goal allows",
    message:
      "A temporary specialist can't do more than the goal's autonomy grant. Choose a lower role, or change the goal's grant first.",
  },
  specialist_goal_ended: {
    title: "This goal has ended",
    message:
      "Specialists can only be added while a goal is active or paused and before its deadline.",
  },
  specialist_limit: {
    title: "Too many specialists",
    message:
      "A goal can have up to five active specialists. Retire one before adding another.",
  },
  // BRW-01..03: browser profiles, takeover and the files they keep.
  browser_profile_forbidden: {
    title: "Browser profiles are personal",
    message:
      "Only team owners and admins signed in through a browser can use browser profiles, and only their own. API tokens can't.",
  },
  browser_profile_exists: {
    title: "You already have that profile",
    message:
      "Another of your browser profiles has this name or account. Choose a different name, or open the existing profile.",
  },
  browser_profile_limit: {
    title: "Too many browser profiles",
    message: "You can keep 20 browser profiles. Delete one you no longer use.",
  },
  browser_profile_request_conflict: {
    title: "That profile request changed",
    message: "The same request was sent with different details. Start again.",
  },
  browser_profile_state_invalid: {
    title: "The saved sign-in can't be opened",
    message:
      "The profile's sealed sign-in was changed or damaged, so it isn't used. Clear the profile and sign in again.",
  },
  browser_profile_state_limit: {
    title: "The sign-in is too large to save",
    message:
      "The site stored more than a profile keeps. Clear the profile and sign in again.",
  },
  browser_profile_changed: {
    title: "The profile was cleared",
    message:
      "This session started before the profile was cleared or deleted, so its sign-in isn't saved.",
  },
  browser_profile_in_use: {
    title: "That profile is already open",
    message:
      "A profile is used by one browser session at a time. Close the other session in the browser panel, then try again.",
  },
  browser_profiles_unavailable: {
    title: "The browser can't use profiles yet",
    message:
      "The browser service is an older version without profile support, so nothing was opened. Ask your admin to update it.",
  },
  browser_takeover_conflict: {
    title: "Someone else is in control",
    message:
      "This browser session is held from another tab or browser. Hand it back there first.",
  },
  browser_session_ended: {
    title: "That browser session ended",
    message:
      "It was closed, timed out or its access was revoked. Ask the bunny to open the profile again.",
  },
  browser_session_no_bunny: {
    title: "No bunny is waiting",
    message:
      "You opened this session yourself, so there's nothing to hand back. Close it when you're done.",
  },
  browser_upload_needs_control: {
    title: "Take over to upload",
    message:
      "Files are uploaded only by you, while you're in control of the browser. Take over, click the file field, then upload.",
  },
  browser_upload_needs_file_field: {
    title: "Click the file field first",
    message: "Click the page's file field so it has focus, then upload.",
  },
  browser_stale_reference: {
    title: "The page changed",
    message:
      "That control is from an earlier look at the page (it changed, or a person took over). Look at the page again.",
  },
  browser_outcome_unknown: {
    title: "We don't know what the browser did",
    message:
      "The browser didn't answer, so the action may or may not have happened. Look at the page before doing anything else.",
  },
  browser_artifact_empty: {
    title: "The file is empty",
    message: "Nothing was kept.",
  },
  browser_artifact_too_large: {
    title: "The file is too large",
    message:
      "Downloads and recordings can be 8 MB and files you add 2 MB at most.",
  },
  browser_artifact_type_refused: {
    title: "That kind of file isn't kept",
    message:
      "Programs, scripts and web pages aren't kept. PDFs, images, ZIP, CSV, text, Markdown and JSON are.",
  },
  browser_artifact_type_mismatch: {
    title: "The file isn't what its name says",
    message: "Its contents don't match its extension, so it wasn't kept.",
  },
  browser_artifact_storage_limit: {
    title: "Your browser files are full",
    message:
      "You can keep 64 MB in 200 files. Delete some in Settings \u203A Browser profiles.",
    action: { label: "Open browser profiles", route: "#/settings/me/browsing" },
  },
  browser_artifact_changed: {
    title: "The file changed",
    message:
      "Its contents no longer match what was kept, so it isn't served. Delete it.",
  },
  browser_artifact_name_invalid: {
    title: "The file needs a name",
    message: "Give the file a name with an extension, such as report.pdf.",
  },
  browser_artifact_request_conflict: {
    title: "That file request changed",
    message: "The same request was sent with a different file. Start again.",
  },
  browser_profile_capture_refused: {
    title: "Profile pages aren't attached",
    message:
      "Pages of a signed-in profile aren't attached to chats, so a bunny never reads account pages this way.",
  },
  // PUB-01: reviewed static publications.
  publication_forbidden: {
    title: "Publishing needs an admin",
    message:
      "Team owners and admins signed in through a browser publish and review publications.",
  },
  publication_unconfigured: {
    title: "Publishing is off",
    message:
      "The server has no publication address. An operator sets publication.origin in the configuration.",
  },
  publication_path_invalid: {
    title: "A file path isn't allowed",
    message:
      "Paths are relative, without .., hidden (dot) names, backslashes or unusual characters.",
  },
  publication_secret_file: {
    title: "A secret-looking file was refused",
    message:
      "Files such as .env, keys, credentials and repository folders are never published. Remove them and try again.",
  },
  publication_secret_content: {
    title: "A file looks like it holds a secret",
    message:
      "A token, key or password was found in a file. Remove it and try again; nothing was published.",
  },
  publication_type_refused: {
    title: "A file type can't be published",
    message:
      "Only static web files are published: HTML, CSS, JavaScript, JSON, text, images, fonts and PDFs.",
  },
  publication_type_mismatch: {
    title: "A file isn't what its name says",
    message: "Its contents don't match its extension. Fix it and try again.",
  },
  publication_file_empty: {
    title: "A file is empty",
    message: "Remove empty files and try again.",
  },
  publication_file_too_large: {
    title: "A file is too large",
    message: "Each file can be 1 MB at most.",
  },
  publication_path_collision: {
    title: "Two files differ only in case",
    message: "Rename one of them; such files would clash once served.",
  },
  publication_too_many_files: {
    title: "Too many files",
    message: "A publication can have 200 files at most.",
  },
  publication_too_large: {
    title: "The publication is too large",
    message: "A publication can be 2 MB at most.",
  },
  publication_empty: {
    title: "There's nothing to publish",
    message: "Choose files, or a workspace folder that holds the built site.",
  },
  publication_request_conflict: {
    title: "That publication request changed",
    message: "The same request was sent with different files. Start again.",
  },
  publication_manifest_changed: {
    title: "The files changed since review",
    message:
      "You can only confirm the exact list of files you reviewed. Open the publication again and review it.",
  },
  publication_expired: {
    title: "This publication expired",
    message: "Prepare it again to publish it.",
  },
  publication_outcome_unknown: {
    title: "We don't know if it was published",
    message:
      "The answer was lost. Use Check status: Helix Agentspace compares what's served with the manifest and never publishes again on its own.",
  },
  publication_already_activated: {
    title: "It was already published",
    message:
      "This publication was confirmed before. Open it to see its address, or prepare a new one.",
  },
  publication_activation_running: {
    title: "Publishing is in progress",
    message: "Wait a moment, then check the publication again.",
    retryable: true,
  },
};
const words = (code) => code.replaceAll("_", " ").trim();
const sentence = (text) =>
  text ? text[0].toUpperCase() + text.slice(1) : text;
function derive(code) {
  const patterns = [
    [
      /^(.+)_outcome_unknown$/,
      (s) => [
        `${sentence(s)} may not have finished`,
        `We couldn't confirm whether the ${s} finished. Check its result before trying again.`,
      ],
    ],
    [
      /^invalid_(.+)$/,
      (s) => [`Invalid ${s}`, `Check the ${s} and try again.`],
    ],
    [
      /^(.+)_rate_limited$/,
      (s) => [
        `${sentence(s)} is busy`,
        "Too many requests right now. Try again shortly.",
        true,
      ],
    ],
    [
      /^(.+)_(limit|limits|too_large|too_long)$/,
      (s) => [
        `${sentence(s)} limit reached`,
        `This is over the limit for ${s}. Reduce it and try again.`,
      ],
    ],
    [
      /^(.+)_(unavailable|not_ready|disabled|capacity)$/,
      (s) => [
        `${sentence(s)} isn't available`,
        `${sentence(s)} isn't available right now. Try again later or check its settings.`,
        true,
      ],
    ],
    [
      /^(.+)_(changed|conflict|mismatch|replay_blocked)$/,
      (s) => [
        `${sentence(s)} changed`,
        `${sentence(s)} changed while you were working. Reload and try again.`,
      ],
    ],
    [
      /^(.+)_(denied|forbidden|not_owned|not_allowed)$/,
      (s) => [
        `Not allowed`,
        `You don't have permission for this ${s}. Ask a team admin.`,
      ],
    ],
    [
      /^(.+)_(required)$/,
      (s) => [`${sentence(s)} required`, `Add the ${s} first, then try again.`],
    ],
    [
      /^(.+)_(missing|not_found|deleted)$/,
      (s) => [
        `${sentence(s)} not found`,
        `The ${s} couldn't be found. It may have been removed.`,
      ],
    ],
    [
      /^(.+)_(expired|revoked)$/,
      (s) => [
        `${sentence(s)} expired`,
        `The ${s} is no longer valid. Renew it and try again.`,
      ],
    ],
    [
      /^(.+)_(unknown)$/,
      (s) => [
        `${sentence(s)} outcome unknown`,
        `We couldn't confirm whether the ${s} finished. Check before trying again.`,
      ],
    ],
    [
      /^(.+)_(active|busy|pending|running_first)$/,
      (s) => [
        `${sentence(s)} in progress`,
        `Wait for the current ${s} to finish, then try again.`,
        true,
      ],
    ],
    [
      /^(.+)_(unsupported)$/,
      (s) => [`${sentence(s)} not supported`, `This ${s} isn't supported yet.`],
    ],
    [
      /^(.+)_(failed|error)$/,
      (s) => [
        `${sentence(s)} failed`,
        `The ${s} didn't complete. Try again.`,
        true,
      ],
    ],
  ];
  for (const [pattern, describe] of patterns) {
    const match = pattern.exec(code);
    if (match) {
      const [title, message, retryable] = describe(words(match[1]));
      return { title, message, retryable };
    }
  }
  return {
    title: sentence(words(code)),
    message: `Helix Agentspace couldn't complete this request (${words(code)}). Try again, or ask your admin if it keeps happening.`,
  };
}
function describeError(code) {
  const entry = Object.hasOwn(catalogue, code) ? catalogue[code] : derive(code);
  return { ...entry, retryable: entry.retryable ?? false };
}
const catalogedErrorCodes = Object.freeze(Object.keys(catalogue));
export { catalogedErrorCodes, describeError };
